import NavigationRequests from "../visComponents/navigation/navigationRequests";

export default class SelectionWindowBvRequests extends NavigationRequests {

  renderErrorPopup(message) {
    console.log('error handling needed', message);
    // this.props.changeMessageBoxState({
    //   visible: true,
    //   error: true,
    //   message,
    //   buttons: [{
    //     text: 'Ok',
    //     color: 'red',
    //     click: () => {
    //       this.props.changeMessageBoxState({visible:false});
    //     }
    //   }]
    // });
  }
}
